import { func, node, oneOfType } from 'prop-types';
import React from 'react';
import useValidation from './useValidation';

const FormContextProvider = ({ children, ...props }) => {
  const [Provider, value] = useValidation(props);

  return (
    <Provider value={value}>
      {typeof children === 'function' ? children(value) : children}
    </Provider>
  );
};

FormContextProvider.propTypes = {
  children: oneOfType([func, node]).isRequired
};

export default FormContextProvider;

export const withFormProvider = (WrappedComponent) => {
  const FormRoot = (props) => (
    <FormContextProvider {...props}>
      {(value) => <WrappedComponent {...props} {...value} />}
    </FormContextProvider>
  );

  return FormRoot;
};
